App.SettingsBillingPaymentMethodController = Em.Controller.extend
  notifier: Em.inject.service('notifier')
  env:      Em.inject.service('environment')

  needs: [ 'settingsBilling', 'settingsBillingTariffs' ]

  billingBinding: 'controllers.settingsBilling'
  billingInfoBinding: 'controllers.settingsBilling.billingInfo'

  bankDetailsBinding: 'controllers.settingsBilling.billingInfo.bank_details.data'
  bankDetailsTypeBinding: 'controllers.settingsBilling.billingInfo.bank_details.bank_details_type'

  isLoading: false

  bank_details: null
  bank_details_type: null
  bank_details_changed: false

  isTabBankAccount: Em.computed.equal('bank_details_type', 'bank_account')
  isTabBankCard: Em.computed.equal('bank_details_type', 'bank_card')

  showApplyButton: (->
    @get('bankDetailsType') != @get('bank_details_type') || @get('bank_details_changed')
  ).property('bankDetailsType', 'bank_details_type', 'bank_details_changed')

  applyPaymentMethodText: (->
    return '' if @get('bankDetailsType') == @get('bank_details_type') && !@get('bank_details_changed')
    return Em.I18n.t 'billing.form.update_requisites' if @get('bankDetailsType') == @get('bank_details_type') && @get('bank_details_changed')
    return Em.I18n.t 'billing.form.enable_pay_by_card' if @get('bank_details_type') == 'bank_card'
    return Em.I18n.t 'billing.form.enable_pay_by_bank' if @get('bank_details_type') == 'bank_account'
  ).property('bank_details_type')

  init: (->
    @set('bank_details_type', @get('bankDetailsType'))
    @set('bank_details', @get('bankDetails') || {})
    # @set('bank_details_type', @get('billingInfo.bank_details.bank_details_type'))
  ).on('init')

  actions:
    changed: ->
      @set('bank_details_changed', true)
    closeModal: ->
      @transitionToRoute 'settings.billing'
      false

    applyPaymentMethod: ->
      @set('isLoading', true)

      billingInfo = @get('billingInfo')

      billingInfo.setBankDetails({bank_details_type: @get('bank_details_type'), data: @get('bank_details')})
      .then =>
        @set('isLoading', false)
        @set('bank_details_changed', false)
        @get('controllers.settingsBilling').set('billingOperations', @store.find('billing_operation'))
        @get('controllers.settingsBilling.billingInfo').reload()
        .then =>
          if @get('controllers.settingsBilling.isStatePaywall')
            @transitionToRoute('settings.billing.tariffs')
            Em.run.later =>
              @get('controllers.settingsBillingTariffs').send('applyTariff')
          else
            @transitionToRoute 'settings.billing'

      false
